// extracted by mini-css-extract-plugin
var _1 = "DocumentDraggableCellClone-moduleTableCellClone__hNwEK TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "DocumentDraggableCellClone-modulecounter__PxwgH";
var _3 = "DocumentDraggableCellClone-modulemultiple__ayQHP";
export { _1 as "TableCellClone", _2 as "counter", _3 as "multiple" }
